enum verifiedParentalConsentRequestType {
  ChargebackReenableAccount = 'ChargebackReenableAccount',
  SavePaymentMethods = 'SavePaymentMethods',
  UpdateUserSetting = 'UpdateUserSetting',
  UpdateBirthdate = 'UpdateBirthdate',
  LinkToChild = 'LinkToChild',
  Unknown = 'Unknown'
}

export default verifiedParentalConsentRequestType;
